"use strict";

exports.__esModule = true;
exports.createStorages = void 0;
var _storage = require("../utils/storage");
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const createStorages = api => {
  return {
    nativeBalance: address => _storage.Storage.create({
      api: api,
      path: 'query.system.account',
      params: [address]
    })
  };
};
exports.createStorages = createStorages;